<template>
  <b-container fluid>
    <div class="d-none d-md-block">
      <sidebar
        id="desktop-sidebar"
        :title="`Welcome,${user.fname}`"
        :tabs="tabs"
        :isMobile="false"
      />
    </div>
    <div class="d-block d-md-none">
      <sidebar
        id="mobile-sidebar"
        :title="`Welcome,${user.fname}`"
        :tabs="tabs"
        :isMobile="true"
      />
    </div>
    <router-view></router-view>
  </b-container>
</template>
<script>
import Sidebar from '@/components/Sidebar'

export default {
  name: "adminDashboard",
  components: {
    Sidebar
  },
  data () {
    return {
      currentTab: "users",
      user: this.$store.state.auth.data,
      tabs: [
        {
          title: "users",
          icon: 'person',
          name: 'adminUsers'
        },
        {
          title: "companies",
          icon: 'building',
          name: 'adminCompanies'
        },
        {
          title: "positions",
          icon: 'briefcase',
          name: 'adminPositions'
        },
        {
          title: "skills",
          icon: 'card-checklist',
          name: 'adminSkills'
        },
        {
          title: "privacy",
          icon: 'file-text',
          name: 'adminPrivacy'
        },
        {
          title: "terms",
          icon: 'file-text',
          name: 'adminTerms'
        }
      ]
    }
  }
}
</script>